












































import {Component, Emit, Prop} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import UserCreate from "@/models/user/UserCreate";
import AsiAutocomplete from "@/components/common/AsiAutocomplete";
import {AxiosError} from "axios";
import {CompanyType, Gender, UserCreateType} from "@/helpers/constants";
import AsiTextField from "@/components/common/AsiTextField";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import CompanySimple from "@/models/company/CompanySimple";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";
import AsiCountryAutocompleteInput from "@/components/common/AsiCountryAutocompleteInput.vue";
import {enumToSelectItems} from "@/helpers/functions_asi";
import {SnackbarMessage} from "@/models/SnackbarMessage";

@Component({
	components: {
		AsiCountryAutocompleteInput,
		CompanyAutocompleteInput,
		AsiAvatar, AsiRadioGroup, AsiTextField, AsiAutocomplete, AsiDialogFormLayout
	}
})
export default class UserCreateDialog extends AsiDialogForm {

	@Prop({type: Object, default: null})
	public company!: CompanySimple | null;

	@Prop({type: Boolean, default: false})
	public noRedirectOnSave!: boolean;

	private model: UserCreate = new UserCreate();
	private userCreateTypes = UserCreateType;
	private genderOptions = enumToSelectItems(Gender, true);
	private typeSelectionVisible = false;

	public mounted(): void {
		if (this.company) {
			this.model.companyId = this.company.id;
			this.typeSelectionVisible = this.company?.type === CompanyType.internal;
		}
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([this.model], form);
		return event;
	}

	private companyChanged(companyId: string | null): void {
		if (companyId === null) {
			this.typeSelectionVisible = false;
			this.model.userCreateType = null;
			return;
		}

		this.loading = true;
		this.$companyService.company(companyId)
			.then(c => {
				const isInternal = c.type === CompanyType.internal;
				this.typeSelectionVisible = isInternal;
				if (!isInternal) this.model.userCreateType = null;
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => this.loading = false);
	}

	private requestSave(event: Event): void {
		this.loading = true;
		this.$userService.create(this.model)
			.then(res => {
				if (!this.noRedirectOnSave) {
					this.$router.push({name: 'User', params: {id: res.id}});
				}
				this.save(event);
			})
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
